module.exports = __webpack_public_path__ + "img/han_jie_gong_zuo_zhan-icon1.f5b65e95.png";